import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Update, findOne } from "../../../utils/apis/master/appsetup/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS, Select2Data } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import { allPaymentMethod, Country } from "../../../utils/apis/common";
import Select from "react-select";

function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    control,
  } = useForm();

  // const image = watch("image");
  const qr_code = watch("qr_code");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("qr_code", data?.qr_code[0]);

      sendData.append("version", data?.version);
      sendData.append("email", data?.email);
      sendData.append("support_contact_no", data?.support_contact_no);
      sendData.append("rummy_commission", data?.rummy_commission);
      sendData.append("teen_patti_commission", data?.teen_patti_commission);
      sendData.append("appID", data?.appID);
      sendData.append("appSign", data?.appSign);
      sendData.append("upi_id", data?.upi_id);
      sendData.append("razorpay_key", data?.razorpay_key);
      sendData.append("secret_key", data?.secret_key);
      sendData.append("imb_token", data?.imb_token);
      sendData.append("upi_gateway_token", data?.upi_gateway_token);
      sendData.append("payment_method_id", data?.payment_method_id);
      sendData.append("min_withdraw", data?.min_withdraw);
      sendData.append("min_deposit", data?.min_deposit);

      const result = await Update(id, sendData);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.message,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            setError(key, {
              message: response.errors[key].msg,
            });
          }
        }
        // setError("name", {
        //   message: response?.errors?.name?.msg,
        // });
      }
    } catch (error) {
      for (const key in error?.response?.data?.errors) {
        if (error?.response?.data?.errors.hasOwnProperty(key)) {
          setError(key, {
            message: error?.response?.data?.errors[key].msg,
          });
        }
      }
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const [paymentMethods, setPaymentMethods] = useState([]);

  const GetAllPaymentMethod = async () => {
    const response = await allPaymentMethod();
    if (response?.data?.success) {
      setPaymentMethods(await Select2Data(response?.data?.data, "country_id"));
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);

      const data = response?.data?.data;

      if (data) {
        reset({
          ...data,
          payment_method_id: data.payment_method_id?.value || null,
        });
      }
    }
  };
  useEffect(() => {
    GetEditData();
    GetAllPaymentMethod();
  }, [id]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Edit App Set Up"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Version * </Form.Label>
                        <Form.Control
                          type="text"
                          name="version"
                          placeholder="Version"
                          className={classNames("", {
                            "is-invalid": errors?.version,
                          })}
                          {...register("version", {
                            required: "Version is required",
                            // pattern: {
                            //   value: /^\d+\.\d+\.\d+$/, // Regex for version format (e.g., 1.0.0)
                            //   message:
                            //     "Invalid version format. Use X.Y.Z (e.g., 1.0.0)",
                            // },
                          })}
                        />{" "}
                        <Form.Label className="">
                          Format. Use X.Y.Z (e.g., 1.0.0)
                        </Form.Label>
                        <br className="m-0 p-0" />
                        {errors.version && (
                          <span className="text-danger ">
                            {errors.version.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Email"
                          className={classNames("", {
                            "is-invalid": errors?.email,
                          })}
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors.email && (
                          <span className="text-danger">
                            {errors.email.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Support Contact No *</Form.Label>
                        <Form.Control
                          type="number"
                          name="support_contact_no"
                          placeholder="Support Contact No"
                          className={classNames("", {
                            "is-invalid": errors?.support_contact_no,
                          })}
                          {...register("support_contact_no", {
                            required: "Support Contact No is required",
                            // pattern: {
                            //   value: /^[0-9]+$/, // only numbers
                            //   message: "Only digits are allowed",
                            // },
                            // minLength: {
                            //   value: 10,
                            //   message: "Contact No must be exactly 10 digits",
                            // },
                            // maxLength: {
                            //   value: 10,
                            //   message: "Contact No must be exactly 10 digits",
                            // },
                          })}
                        />
                        {errors.support_contact_no && (
                          <span className="text-danger">
                            {errors.support_contact_no.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Rummy Commission *</Form.Label>
                        <Form.Control
                          type="number"
                          name="rummy_commission"
                          placeholder="Rummy Commission"
                          className={classNames("", {
                            "is-invalid": errors?.rummy_commission,
                          })}
                          {...register("rummy_commission", {
                            required: "Rummy Commission is required",
                            validate: (value) => {
                              if (!value) return "Rummy Commission is required";
                              // Validate rummy_commission discount
                              if (parseFloat(value) < 0) {
                                return "Rummy Commission should not be less then 0";
                              }
                              if (parseFloat(value) > 100) {
                                return "Rummy Commission should not be Greater then 100";
                              }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.rummy_commission && (
                          <span className="text-danger">
                            {errors.rummy_commission.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Teen Patti Commission *</Form.Label>
                        <Form.Control
                          type="number"
                          name="teen_patti_commission"
                          placeholder="Teen Patti Commission"
                          className={classNames("", {
                            "is-invalid": errors?.teen_patti_commission,
                          })}
                          {...register("teen_patti_commission", {
                            required: "Teen Patti Commission is required",
                            validate: (value) => {
                              if (!value)
                                return "Teen Patti Commission is required";
                              // Validate teen_patti_commission discount
                              if (parseFloat(value) < 0) {
                                return "Teen Patti Commission should not be less then 0";
                              }
                              if (parseFloat(value) > 100) {
                                return "Teen Patti Commission should not be Greater then 100";
                              }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.teen_patti_commission && (
                          <span className="text-danger">
                            {errors.teen_patti_commission.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>UPI ID *</Form.Label>
                        <Form.Control
                          type="text"
                          name="upi_id"
                          placeholder="UPI ID"
                          className={classNames("", {
                            "is-invalid": errors?.upi_id,
                          })}
                          {...register("upi_id", {
                            required: "UPI ID is required",
                            validate: (value) => {
                              if (!value) return "UPI ID is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.upi_id && (
                          <span className="text-danger">
                            {errors.upi_id.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Razorpay Key *</Form.Label>
                        <Form.Control
                          type="text"
                          name="razorpay_key"
                          placeholder="Razorpay Key"
                          className={classNames("", {
                            "is-invalid": errors?.razorpay_key,
                          })}
                          {...register("razorpay_key", {
                            required: "Razorpay Key is required",
                            validate: (value) => {
                              if (!value) return "Razorpay Key is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.razorpay_key && (
                          <span className="text-danger">
                            {errors.razorpay_key.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Secret Key *</Form.Label>
                        <Form.Control
                          type="text"
                          name="secret_key"
                          placeholder="Secret Key"
                          className={classNames("", {
                            "is-invalid": errors?.secret_key,
                          })}
                          {...register("secret_key", {
                            required: "Secret Key is required",
                            validate: (value) => {
                              if (!value) return "Secret Key is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.secret_key && (
                          <span className="text-danger">
                            {errors.secret_key.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>IMB Token *</Form.Label>
                        <Form.Control
                          type="text"
                          name="imb_token"
                          placeholder="IMB Token"
                          className={classNames("", {
                            "is-invalid": errors?.imb_token,
                          })}
                          {...register("imb_token", {
                            required: "IMB Token is required",
                            validate: (value) => {
                              if (!value) return "IMB Token is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.imb_token && (
                          <span className="text-danger">
                            {errors.imb_token.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>UPI Gateway Token *</Form.Label>
                        <Form.Control
                          type="text"
                          name="upi_gateway_token"
                          placeholder="UPI Gateway Token"
                          className={classNames("", {
                            "is-invalid": errors?.upi_gateway_token,
                          })}
                          {...register("upi_gateway_token", {
                            required: "UPI Gateway Token is required",
                            validate: (value) => {
                              if (!value)
                                return "UPI Gateway Token is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.upi_gateway_token && (
                          <span className="text-danger">
                            {errors.upi_gateway_token.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="row">
                      <div className="col-md-12 col-sm-12 mt-3">
                        <Form.Group
                          className="form-field"
                          controlId="formBasicPaymentMethod">
                          <Form.Label>Payment Method*</Form.Label>

                          <Controller
                            name="payment_method_id"
                            control={control}
                            rules={{
                              required: "Select Payment Method",
                            }}
                            render={({ field }) => (
                              <Select
                                options={paymentMethods}
                                placeholder="Select Payment Method"
                                isClearable
                                value={
                                  paymentMethods.find(
                                    (option) =>
                                      Number(option.value) ===
                                      Number(field.value),
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption?.value || null);
                                }}
                                onBlur={field.onBlur}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors.payment_method_id
                                      ? "red"
                                      : baseStyles.borderColor,
                                  }),
                                }}
                              />
                            )}
                          />

                          {errors.payment_method_id && (
                            <span className="text-danger">
                              {errors.payment_method_id.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Min Deposit *</Form.Label>
                        <Form.Control
                          type="text"
                          name="min_deposit"
                          placeholder="Min Deposit"
                          className={classNames("", {
                            "is-invalid": errors?.min_deposit,
                          })}
                          {...register("min_deposit", {
                            required: "Min Deposit is required",
                            validate: (value) => {
                              if (!value) return "Min Deposit is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.min_deposit && (
                          <span className="text-danger">
                            {errors.min_deposit.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Min Withdraw *</Form.Label>
                        <Form.Control
                          type="text"
                          name="min_withdraw"
                          placeholder="Min Withdraw"
                          className={classNames("", {
                            "is-invalid": errors?.min_withdraw,
                          })}
                          {...register("min_withdraw", {
                            required: "Min Withdraw is required",
                            validate: (value) => {
                              if (!value) return "Min Withdraw is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.min_withdraw && (
                          <span className="text-danger">
                            {errors.min_withdraw.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>App ID *</Form.Label>
                        <Form.Control
                          type="number"
                          name="appID"
                          disabled
                          placeholder="App ID"
                          className={classNames("", {
                            "is-invalid": errors?.appID,
                          })}
                          {...register("appID", {
                            required: "App ID is required",
                            validate: (value) => {
                              if (!value) return "App ID is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.appID && (
                          <span className="text-danger">
                            {errors.appID.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>App Sign *</Form.Label>
                        <Form.Control
                          type="text"
                          name="appSign"
                          disabled
                          placeholder="App Sign"
                          className={classNames("", {
                            "is-invalid": errors?.appSign,
                          })}
                          {...register("appSign", {
                            required: "App Sign is required",
                            validate: (value) => {
                              if (!value) return "App Sign is required";

                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.appSign && (
                          <span className="text-danger">
                            {errors.appSign.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    {/* <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Bus Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="bus_percentage"
                          placeholder="Bus Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.bus_percentage,
                          })}
                          {...register("bus_percentage", {
                            required: "Bus Percentage is required",
                            validate: (value) => {
                              if (!value) return "Bus Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Bus Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Bus Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.bus_percentage && (
                          <span className="text-danger">
                            {errors.bus_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Flight Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="flight_percentage"
                          placeholder="Flight Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.flight_percentage,
                          })}
                          {...register("flight_percentage", {
                            required: "Flight Percentage is required",
                            validate: (value) => {
                              if (!value)
                                return "Flight Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Flight Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Flight Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.flight_percentage && (
                          <span className="text-danger">
                            {errors.flight_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div> */}
                    {/* <Form.Label>Customers Percentage : </Form.Label>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Bus Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="c_bus_percentage"
                          placeholder="Bus Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.c_bus_percentage,
                          })}
                          {...register("c_bus_percentage", {
                            required: "Bus Percentage is required",
                            validate: (value) => {
                              // if (!value) return "Bus Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Bus Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Bus Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.c_bus_percentage && (
                          <span className="text-danger">
                            {errors.c_bus_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Flight Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="c_flight_percentage"
                          placeholder="Flight Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.c_flight_percentage,
                          })}
                          {...register("c_flight_percentage", {
                            required: "Flight Percentage is required",
                            validate: (value) => {
                              // if (!value)
                              //   return "Flight Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Flight Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Flight Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.c_flight_percentage && (
                          <span className="text-danger">
                            {errors.c_flight_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <Form.Label>Agent Percentage : </Form.Label>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Bus Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="a_bus_percentage"
                          placeholder="Bus Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.a_bus_percentage,
                          })}
                          {...register("a_bus_percentage", {
                            required: "Bus Percentage is required",
                            validate: (value) => {
                              // if (!value) return "Bus Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Bus Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Bus Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.a_bus_percentage && (
                          <span className="text-danger">
                            {errors.a_bus_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Flight Percentage *</Form.Label>
                        <Form.Control
                          type="number"
                          name="a_flight_percentage"
                          placeholder="Flight Percentage"
                          className={classNames("", {
                            "is-invalid": errors?.a_flight_percentage,
                          })}
                          {...register("a_flight_percentage", {
                            required: "Flight Percentage is required",
                            validate: (value) => {
                              // if (!value)
                              //   return "Flight Percentage is required";
                              // Validate percentage discount
                              // if (parseFloat(value) < 0) {
                              //   return "Flight Percentage should not be less then 0";
                              // }
                              // if (parseFloat(value) > 100) {
                              //   return "Flight Percentage should not be Greater then 100";
                              // }
                              return true; // Return true for valid input
                            },
                          })}
                        />
                        {errors.a_flight_percentage && (
                          <span className="text-danger">
                            {errors.a_flight_percentage.message}
                          </span>
                        )}
                      </Form.Group>
                    </div> */}

                    {/* <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Advertisement Image*</Form.Label>

                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                if (value && value.length > 0) {
                                  const fileTypes = ["jpg", "png", "jpeg"];
                                  const fileType = value[0]?.name
                                    ?.split(".")[1]
                                    ?.toLowerCase();

                                  if (!fileTypes.includes(fileType)) {
                                    return `Please upload a valid file format. (${fileTypes.join(
                                      ", "
                                    )})`;
                                  }

                                  // Optional size and dimension checks
                                  // const sizes = await getDimension(value[0]);
                                  // if (sizes.width !== 800 || sizes.height !== 400) {
                                  //   return "Image width and height must be 800 px and 400 px";
                                  // }
                                  // const fileSize = Math.round(value[0].size / 1024);
                                  // if (fileSize > 500) {
                                  //   return "File size must be lower than 500KB";
                                  // }
                                } else {
                                  return "Please upload an image.";
                                }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />

                        {errors.image && (
                          <span className="text-danger">
                            {errors.image.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Label className="text-center">
                        Advertisement Image Preview
                      </Form.Label>
                      {typeof getValues("image") == "string" ? (
                        <div className="image-preview-container">
                          <img
                            src={IMG_URL + getValues("image")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "150px", height: "130px" }}
                          />
                        </div>
                      ) : (
                        image &&
                        image?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(image[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )
                      )}
                    </div> */}

                    {/* <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail"
                      >
                        <Form.Label>Login Logo Image*</Form.Label>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("qr_code", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg"];
                                const fileType = value[0].name?.split(".")[1];
                                if (!fileTypes.includes(fileType)) {
                                  return `please upload a valid file format. (${fileTypes})`;
                                }
                                // const sizes = await getDimension(value[0]);
                                // if (sizes.width !== 800 && sizes.height !== 400) {
                                //   return "Image width and height must be 800 px and 400  px";
                                // }
                                // const fileSize = Math.round(value[0].size / 1024);
                                // if (fileSize > 500) {
                                //   return "file size must be lower than 500kb";
                                // }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                        {errors.qr_code && (
                          <span className="text-danger">
                            {errors.qr_code.message}
                          </span>
                        )}
                      </Form.Group>
                    </div> */}

                    <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>QR Code*</Form.Label>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.qr_code,
                          })}
                          type="file"
                          {...register("qr_code", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                if (value && value.length > 0) {
                                  const fileTypes = ["jpg", "png", "jpeg"];
                                  const fileName = value[0]?.name;
                                  const fileType = fileName
                                    ?.split(".")
                                    .pop()
                                    ?.toLowerCase();

                                  if (!fileTypes.includes(fileType)) {
                                    return `Please upload a valid file format. (${fileTypes.join(
                                      ", ",
                                    )})`;
                                  }

                                  // Optional: Size and dimension checks
                                  // const sizes = await getDimension(value[0]);
                                  // if (sizes.width !== 800 || sizes.height !== 400) {
                                  //   return "Image width and height must be 800 px and 400 px";
                                  // }
                                  // const fileSize = Math.round(value[0].size / 1024);
                                  // if (fileSize > 500) {
                                  //   return "File size must be lower than 500KB";
                                  // }
                                } else {
                                  return "Please upload an image.";
                                }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                        {errors.qr_code && (
                          <span className="text-danger">
                            {errors.qr_code.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-6 col-sm-12 mt-3">
                      <Form.Label className="text-center">
                        QR Code Preview
                      </Form.Label>
                      {typeof getValues("qr_code") == "string" ? (
                        <div className="image-preview-container">
                          <img
                            src={IMG_URL + getValues("qr_code")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "150px", height: "130px" }}
                          />
                        </div>
                      ) : (
                        qr_code &&
                        qr_code?.length > 0 && (
                          <div className="image-preview-container">
                            <img
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(qr_code[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "100px", height: "100px" }}
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
